import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface SiteShellProps {
  children: React.ReactNode;
  pageTitle: string;
  pageDescription: string;
  pageKeywords: string;
  breadcrumb?: string;
}

function setMeta(attribute: "name" | "property", key: string, content: string) {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function SiteShell({
  children,
  pageTitle,
  pageDescription,
  pageKeywords,
  breadcrumb,
}: SiteShellProps) {
  useEffect(() => {
    document.title = pageTitle;
    setMeta("name", "description", pageDescription);
    setMeta("name", "keywords", pageKeywords);
    setMeta("property", "og:title", pageTitle);
    setMeta("property", "og:description", pageDescription);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", pageTitle);
    setMeta("name", "twitter:description", pageDescription);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    const path = breadcrumb ? breadcrumb : window.location.pathname;
    canonical.setAttribute("href", `${window.location.origin}${path}`);
  }, [pageTitle, pageDescription, pageKeywords, breadcrumb]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}